const FormResources = {

    form_data:{
        staffing_scenario_id:   '',
        name:                   '',
        order:                  '',
        minutes:                '',
        days:                   ''
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'number',
            name:       'Order:',
            model_name: 'order',
            ref:        'order_input',
            ref_alt:    'order_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Minutes:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Days per week:',
            model_name: 'days',
            ref:        'days_input',
            ref_alt:    'days_input_alt',
            required:   true,
        },
    ]

}

export default FormResources;